import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Link } from 'react-transition-progress/next';
import { IconX } from '@/components/ui/icons';
import { IconInstagramFill } from '@/components/ui/icons/IconInstagram-fill';
import { PATHS } from '@/constants/path';

type NavItem = {
  icon?: ReactNode;
  title: string;
  path: string;
};

export const Official = () => {
  const t = useTranslations();
  const NAV_ITEMS: NavItem[] = [
    {
      icon: <IconX width={16} height={16} fillColor='white' />,
      title: t('settings-menu-x'),
      path: PATHS.X,
    },
    {
      icon: <IconInstagramFill width={16} height={16} fillColor='white' />,
      title: t('settings-menu-instagram'),
      path: PATHS.INSTAGRAM,
    },
    {
      title: t('settings-menu-careers'),
      path: PATHS.CAREERS,
    },
  ];

  return (
    <div className='ml-1 flex flex-col pb-5 pt-4 leading-5'>
      {NAV_ITEMS.map((item) => (
        <Link
          key={item.title}
          href={item.path}
          target='_blank'
          className='flex items-center py-2 text-[1rem] font-bold text-white'
        >
          {item.icon && <span className='pr-2'>{item.icon}</span>}
          {item.title}
        </Link>
      ))}
    </div>
  );
};
